var _rect, _rect2, _rect3, _path, _path2, _g, _g2, _rect4, _path3, _path4, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectedAssignedDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 50,
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_56220)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    transform: "translate(-286 -102)",
    fill: "#F4F7FA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 51.9408,
    height: 49.1249,
    rx: 24.5625,
    fill: "#EBEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 24C37.5 30.3715 32.5553 35.5 26.5 35.5C20.4447 35.5 15.5 30.3715 15.5 24C15.5 17.6285 20.4447 12.5 26.5 12.5C32.5553 12.5 37.5 17.6285 37.5 24Z",
    fill: "#E5E5E5",
    stroke: "#767881"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_86_56220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 12,
    width: 23,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 24C37.5 30.3715 32.5553 35.5 26.5 35.5C20.4447 35.5 15.5 30.3715 15.5 24C15.5 17.6285 20.4447 12.5 26.5 12.5C32.5553 12.5 37.5 17.6285 37.5 24Z",
    fill: "white",
    stroke: "#252525"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5808 16.7998C25.1533 16.7998 23.8658 17.6972 23.3197 19.0733C22.7734 20.4507 23.0747 22.0342 24.0847 23.088C25.0947 24.1417 26.6122 24.4562 27.932 23.8862C29.2508 23.3162 30.1108 21.9727 30.1108 20.4833C30.1108 19.5063 29.7383 18.5698 29.077 17.8785C28.4145 17.1885 27.517 16.7998 26.5808 16.7998L26.5808 16.7998Z",
    fill: "#767881",
    stroke: "#767881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2008 35.4C35.2008 41.5254 31.2109 46.3 26.5008 46.3C21.7907 46.3 17.8008 41.5254 17.8008 35.4C17.8008 29.2746 21.7907 24.5 26.5008 24.5C31.2109 24.5 35.2008 29.2746 35.2008 35.4Z",
    fill: "#767881",
    stroke: "#767881"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_86_56220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -255,
    y: -22,
    width: 1521,
    height: 91,
    rx: 9.94788,
    fill: "#FEFEFF"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 51.9408,
    height: 49.1249,
    rx: 24.5625,
    fill: "#EBEFF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 24C40.5 32.5913 33.9782 39.5 26 39.5C18.0218 39.5 11.5 32.5913 11.5 24C11.5 15.4087 18.0218 8.5 26 8.5C33.9782 8.5 40.5 15.4087 40.5 24Z",
    fill: "#E5E5E5",
    stroke: "#767881"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_86_56220",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 8,
    width: 30,
    height: 32
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 24C40.5 32.5913 33.9782 39.5 26 39.5C18.0218 39.5 11.5 32.5913 11.5 24C11.5 15.4087 18.0218 8.5 26 8.5C33.9782 8.5 40.5 15.4087 40.5 24Z",
    fill: "white",
    stroke: "#252525"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_86_56220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1053 14.3999C24.2434 14.3999 22.564 15.5965 21.8517 17.4313C21.1392 19.2678 21.5321 21.3791 22.8495 22.7841C24.1669 24.1891 26.1462 24.6085 27.8678 23.8484C29.5879 23.0885 30.7097 21.2971 30.7097 19.3112C30.7097 18.0086 30.2238 16.7599 29.3613 15.8382C28.4972 14.9182 27.3265 14.3999 26.1053 14.3999L26.1053 14.3999Z",
    fill: "#767881",
    stroke: "#767881"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.501 39.2C37.501 47.4352 32.2486 53.9 26.001 53.9C19.7534 53.9 14.501 47.4352 14.501 39.2C14.501 30.9648 19.7534 24.5 26.001 24.5C32.2486 24.5 37.501 30.9648 37.501 39.2Z",
    fill: "#767881",
    stroke: "#767881"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_86_56220",
    x: -257,
    y: -22,
    width: 1525,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.307813 0 0 0 0 0.326577 0 0 0 0 0.375 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_86_56220"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_86_56220",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_56220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1050,
    fill: "white",
    transform: "translate(-286 -102)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedAssignedDevices);
export default __webpack_public_path__ + "static/media/connected-assigned-devices.681ec1af5ff3682329153d72d240c78c.svg";
export { ForwardRef as ReactComponent };